export const COLUMN_TYPES = {
  PRODUCTS: 'PRODUCTS',
  RECIPES: 'RECIPES',
  INGREDIENTS: 'INGREDIENTS',
};

export const COLUMNS = {
  CHECKBOX: '__check__',
  NAME: 'name',
  CATEGORY: 'category',
  TOTAL: 'total',
  SKU: 'sku',
};

export const VIEW_MODES = {
  CALENDAR: 'calendar',
  DAY: 'day',
};

export const DATE_CHANGE = {
  PREV: 'prev',
  NEXT: 'next',
};

export const PENDING_CELL_CLASSNAME = 'sales-planning-cell--pending';

export const getPendingCellKey = (rowId, field) => `${rowId}|${field}`;
